module.exports = __webpack_public_path__ + "img/pic8.763b33dd.png";